import { cn } from '@/lib/utils';

/**
 * The small number beside a tab label.
 *
 * Renders nothing until the count is known, so a tab never shows a placeholder
 * that later turns into a different number. Zero is worth showing — "this is
 * empty" is the answer someone opened the tab to find, and a row of tabs with
 * no counts means opening every one to discover which hold anything.
 */
export function TabCount({ value }: { value?: number | null }) {
  if (value === null || value === undefined) return null;
  return (
    <span
      className={cn(
        'ml-1.5 rounded px-1.5 py-0.5 text-[11px] font-medium tabular-nums',
        value === 0 ? 'bg-muted text-muted-foreground' : 'bg-primary/10 text-primary'
      )}
    >
      {value}
    </span>
  );
}
